import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { groupByPredicate, sort } from 'app/utils/array';
import BracketMatchesListGroup from 'app/components/Blocks/BracketsBlock/BracketWithStandings/BracketMatchesListGroup';

interface Props {
  matches: TournamentBracketMatch[];
  videogame: VideogameSlug;
  videogameTitle: CounterStrikeVersion | null;
  collapsedByDefault?: boolean;
  selectedTeamId?: number | null;
}

const BracketMatchesList: FC<Props> = ({
  matches,
  videogame,
  videogameTitle,
  collapsedByDefault,
  selectedTeamId
}) => {
  const { t } = useTranslation();
  const { finished, not_started, running } = groupByPredicate(matches, match =>
    match.status === 'postponed' ? 'not_started' : match.status
  );
  const sortedRunning = sort(running ?? [], match => match.begin_at);
  const sortedNotStarted = sort(not_started ?? [], match => match.begin_at);
  const sortedFinished = sort(finished ?? [], match => match.begin_at).reverse();

  return (
    <div>
      {sortedRunning.length > 0 && (
        <BracketMatchesListGroup
          title={t('blocks_bracket_match-list_live_title')}
          matches={sortedRunning}
          videogame={videogame}
          videogameTitle={videogameTitle}
          index={1}
          collapsedByDefault={collapsedByDefault}
          selectedTeamId={selectedTeamId}
        />
      )}
      {sortedNotStarted.length > 0 && (
        <BracketMatchesListGroup
          title={t('blocks_bracket_match-list_upcoming_title')}
          matches={sortedNotStarted}
          videogame={videogame}
          videogameTitle={videogameTitle}
          index={2}
          collapsedByDefault={collapsedByDefault}
          selectedTeamId={selectedTeamId}
        />
      )}
      {sortedFinished.length > 0 && (
        <BracketMatchesListGroup
          title={t('blocks_bracket_match-list_past_title')}
          matches={sortedFinished}
          videogame={videogame}
          videogameTitle={videogameTitle}
          index={3}
          collapsedByDefault={collapsedByDefault}
          selectedTeamId={selectedTeamId}
        />
      )}
    </div>
  );
};

BracketMatchesList.displayName = 'BracketMatchesList';

export default BracketMatchesList;
